import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import { thunk } from "redux-thunk";

import eventsReducer from "./eventsSlice";
import notificationReducer from "./notificationSlice";
import profileReducer from "./profileSlice";
import reportReducer from "./reportsSlice";
import commonReducer from "./commonSlice";

// Combine reducers
const rootReducer = combineReducers({
  events: eventsReducer,
  notifications: notificationReducer,
  profile: profileReducer,
  report: reportReducer,
  common: commonReducer,
});

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["common"], 
};

// Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // prevents redux-persist warnings/errors
    }),
});

// Persistor
export const persistor = persistStore(store);